const roles = [
  {
    value: 'SHIPPER_ADMIN',
    label: 'Shipper Admin'
  },
  {
    value: 'SHIPPER_SUPER_ADMIN',
    label: 'Shipper Super Admin'
  },
  {
    value: 'SHIPPER_MONITORING',
    label: 'Shipper Monitoring'
  },
]

const getRoleText = function (value) {
  const role = roles.find(i => i.value === value)
  return (role && role.label) || ''
}

export default {
  userAdminDatabase: 'Database User Admin',
  edit: 'Ubah User Admin',
  create: 'Buat User Admin Baru',
  searchtext: 'Pencarian',
  name: 'Nama',
  phone: 'No telepon',
  email: 'Email',
  role: 'Role',
  successCreate: 'Berhasil Menambahkan Admin',
  successEdit: 'Berhasil Mengubah Data Admin',
  userAdminDeleteConfirmMsg: 'Apakah Anda yakin ingin menghapus akun ini?',
  userAdminDeleteSuccessMsg: 'Berhasil menghapus akun',
  resetPasswordButtonLabel: 'Reset Password',
  resetPasswordConfirmMsg: 'Apakah Anda yakin ingin me-reset password akun ini?',
  resetPasswordSuccessMsg: 'Berhasil me-reset password akun',
  roles,
  getRoleText,
}
